import React from 'react';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = ['Te levantás hinchada aunque cenaste liviano y no entendés por qué', 'El jean te cierra a la mañana y no te cierra a la tarde. El mismo jean. El mismo día.', 'Cada vez que comés afuera llegás a casa con la panza explotada sin saber qué falló'];
export function PainBlock() {
  return <section className="py-20 px-4 bg-black border-t border-white/5 pt-[8px] pb-[8px]" data-id="element-212">
      <div className="max-w-3xl mx-auto" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-214">
          <h2 className="sm:text-4xl font-extrabold text-white mb-6 text-[24px]" data-id="element-215">
            ¿Cuántos lunes más vas a despertar así?
          </h2>
          <p className="text-gray-300 mb-4 text-[16px]" data-id="element-216">
            Querés cuidarte. Intentás comer bien. Pero igual amanecés con la
            cara hinchada, la panza dura y esa sensación de que el cuerpo no es
            tuyo.
          </p>
          <p className="text-xl font-bold text-brand-green mt-8" data-id="element-217">
            No es falta de voluntad. Es falta de un sistema.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="backdrop-blur-sm border-l-4 border-brand-pink p-6 sm:p-10 rounded-r-2xl bg-[#B9000000]" data-id="element-218">
          <p className="font-bold text-gray-400 uppercase tracking-wider text-sm mb-6" data-id="element-219">
            ❌ Lo que estás viviendo ahora mismo:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-220">
            {painPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-left" data-id="element-221">
                <X className="text-brand-pink shrink-0 mt-1" size={20} data-id="element-222" />
                <span className="text-gray-200 font-medium leading-relaxed" data-id="element-223">
                  {point}
                </span>
              </li>)}
          </ul>

          <div className="pt-8 border-t border-white/10" data-id="element-224">
            <p className="sm:text-3xl font-extrabold text-[20px] text-[#38B900]" data-id="element-225">
              ¿Y si este fuera el último lunes que te levantás así?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}